import { useDIContainer } from '@/container/RouteContainerProvider';
import type { AnalyticsSurface } from './AnalyticsSurface';
import { SurfaceRegistry } from './SurfaceRegistry';

/** The {@link SurfaceRegistry} resolved from the nearest DI container. */
export function useSurfaceRegistry(): SurfaceRegistry {
    return useDIContainer().resolve(SurfaceRegistry);
}

/** The registered surface definition for `surfaceId`, or undefined for an unknown surface. */
export function useSurface(surfaceId: string | undefined): AnalyticsSurface | undefined {
    return useSurfaceRegistry().find(surfaceId);
}
